export enum KnownInboxLabel {
  ARCHIVED = "ARCHIVED",
  CATEGORY_FORUMS = "CATEGORY_FORUMS",
  CATEGORY_PERSONAL = "CATEGORY_PERSONAL",
  CATEGORY_PROMOTIONS = "CATEGORY_PROMOTIONS",
  CATEGORY_UPDATES = "CATEGORY_UPDATES",
  DRAFT = "DRAFT",
  IMPORTANT = "IMPORTANT",
  INBOX = "INBOX",
  SENT = "SENT",
  SPAM = "SPAM",
  STARRED = "STARRED",
  TRASH = "TRASH",
  UNREAD = "UNREAD",
  RED_STAR = "RED_STAR",
  ORANGE_STAR = "ORANGE_STAR",
  YELLOW_STAR = "YELLOW_STAR",
  GREEN_STAR = "GREEN_STAR",
  BLUE_STAR = "BLUE_STAR",
  PURPLE_STAR = "PURPLE_STAR",
  RED_CIRCLE = "RED_CIRCLE",
  ORANGE_CIRCLE = "ORANGE_CIRCLE",
  YELLOW_CIRCLE = "YELLOW_CIRCLE",
  GREEN_CIRCLE = "GREEN_CIRCLE",
  BLUE_CIRCLE = "BLUE_CIRCLE",
  PURPLE_CIRCLE = "PURPLE_CIRCLE",
  QW_AI_FORWARDED = "QW-AI Forwarded",
  QW_AI_PROCESSING = "QW-AI Processing",
  QW_AI_QUOTE = "QW-AI quote",
  QW_AI_SUBMISSION = "QW-AI submission",
  ALL_MAIL = "ALL_MAIL",
}
